import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Settings|Metadata|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.ClientMetadata,
	portal: 'SP',
};

export type SPSystemMetadataLocNames =
	| 'SPSystemMetadataTitlePage'
	| 'SPSystemMetadataLabelType'
	| 'SPSystemMetadataLabelExternalId'
	| 'SPSystemMetadataLabelAttributeName'
	| 'SPSystemMetadataLabelValue'
	| 'SPSystemMetadataLabelActions'
	| 'SPSystemMetadataLabelFilterByType'
	| 'SPSystemMetadataLabelFilterByExternalId'
	| 'SPSystemMetadataEditSuccess'
	| 'SPSystemMetadataEditValueTooltip';

export const spSystemMetadataLocs: LocDefs<SPSystemMetadataLocNames> = {
	SPSystemMetadataTitlePage: {
		defaultValue: 'System Metadata',
		description: 'Page title for system metadata.',
		displayPath: `${pathStart}Title`,
		displayType: 'Title',
		...sharedProperties,
	},
	SPSystemMetadataLabelType: {
		defaultValue: 'Type',
		description: 'Column header for metadata type.',
		displayPath: `${pathStart}Type`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPSystemMetadataLabelExternalId: {
		defaultValue: 'External ID',
		description: 'Column header for external ID.',
		displayPath: `${pathStart}External Id`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPSystemMetadataLabelAttributeName: {
		defaultValue: 'Attribute Name',
		description: 'Column header for attribute name.',
		displayPath: `${pathStart}Attribute Name`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPSystemMetadataLabelValue: {
		defaultValue: 'Value',
		description: 'Column header for attribute value.',
		displayPath: `${pathStart}Value`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPSystemMetadataLabelActions: {
		defaultValue: 'Actions',
		description: 'Column header for actions.',
		displayPath: `${pathStart}Actions`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPSystemMetadataLabelFilterByType: {
		defaultValue: 'Filter by Type',
		description: 'Label for the type filter menu.',
		displayPath: `${pathStart}Filter By Type`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPSystemMetadataLabelFilterByExternalId: {
		defaultValue: 'Filter by External ID',
		description: 'Label for the external ID filter menu.',
		displayPath: `${pathStart}Filter By External Id`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPSystemMetadataEditSuccess: {
		defaultValue: 'Value updated successfully.',
		description: 'Success message after editing a metadata value.',
		displayPath: `${pathStart}Edit Success`,
		displayType: 'Content',
		...sharedProperties,
	},
	SPSystemMetadataEditValueTooltip: {
		defaultValue: 'Edit value',
		description: 'Tooltip for the edit value button.',
		displayPath: `${pathStart}Edit Value Tooltip`,
		displayType: 'Label',
		...sharedProperties,
	},
};

export type SPSystemMetadataLocType = LocMap<SPSystemMetadataLocNames>;
